type ContactNameFields = {
  firstName?: string
  lastName?: string
  email?: string
  communicationName?: string
}

/**
 * Returns a display name for a contact based on available fields.
 * Priority: firstName + lastName > firstName | lastName > communicationName > email > 'No name'
 */
export const getContactDisplayName = (contact: ContactNameFields): string => {
  const firstName = contact.firstName?.trim() || ''
  const lastName = contact.lastName?.trim() || ''
  const communicationName = contact.communicationName?.trim() || ''

  if (firstName && lastName) {
    return `${firstName} ${lastName}`
  }

  return firstName || lastName || communicationName || contact.email || 'No name'
}

/**
 * Returns initials for a contact (up to 2 characters).
 * Uses first letter of firstName and lastName, falls back to email.
 */
export const getContactInitials = (
  contact: Pick<ContactNameFields, 'firstName' | 'lastName' | 'email'>
): string => {
  const first = contact.firstName?.trim()?.charAt(0) || ''
  const last = contact.lastName?.trim()?.charAt(0) || ''
  const email = contact.email?.trim()?.charAt(0) || ''

  const firstChar = (first || email).toUpperCase()
  const lastChar = last.toUpperCase()

  return `${firstChar}${lastChar}`
}
